import React from "react";
import variables from "../../themes/base/styles/variables";
import { TwoRow } from "../../core/layouts";
import { Text } from "react_reusable_components";

const viewRoleDetailsFieldStyle = {
  displayPropertyStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightNormal,
    fontWeight: variables.fontWeightBold,
    color: variables.textDefault,
  },
  displayValueStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  roleDetailsWrapperStyle: {
    gap: variables.gapXS3,
  },
};

export default function ViewFieldContainer({
  displayProperty,
  displayValue,
  customStyle,
  valueStyle,
  propertyStyle,
}) {
  return (
    <TwoRow
      style={{
        ...viewRoleDetailsFieldStyle.roleDetailsWrapperStyle,
        ...customStyle,
      }}
      topSection={
        <Text
          style={{
            ...viewRoleDetailsFieldStyle.displayPropertyStyle,
            ...propertyStyle,
          }}
        >
          {displayProperty}
        </Text>
      }
      bottomSection={
        <Text
          style={{
            ...viewRoleDetailsFieldStyle.displayValueStyle,
            ...valueStyle,
          }}
        >
          {displayValue}
        </Text>
      }
    />
  );
}
